import React from 'react'
import './about.css'
import Logo from '../../assets/main.png'
import cv from '../../assets/Kashaf_webdev_cv.pdf'
import{HiDownload} from 'react-icons/hi'
import Card from '../../components/Card'
import data from './data'
const About = () => {
   return (
     <section id="about">
     <h1  className='sec-title'>ABOUT ME</h1>
     <div className='container about__container'>
     <div className='about__left'>
     <div className='about_portrait'>

        <img src={Logo} alt=""></img>

      </div>
    </div>
    <div className='about__right'>
    <div className='about__cards'>
{
  data.map(item=>(
    <Card key={item.id} className='about__card'>
      <span className='about__card-icon'>{
        item.icon}</span>
      <h5>{item.title}</h5>
      <small>{item.desc}</small>
    </Card> 
  ))
}

    </div>
      <p className='text'>Blending code and creativity, I sculpt digital experiences that captivate and inspire</p>
        
{/* <button class="button-85" role="button" style={{marginBottom:"1rem"}}>
<a href={cv} download  style={{color:"var(--secondary)"}}>Download CV</a>
       
</button> */}


        <p className='text'> I merge technical expertise with a passion for user-centric design. With a penchant for continuous learning and a dedication to delivering excellence, I strive to make meaningful contributions in the digital realm</p> </div>
    </div>
      </section>

  )
}

export default About
